var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"id-desc"},[_c('span',{staticClass:"id-desc__id"},[_vm._v(_vm._s(_vm.id))]),(_vm.id !== null && _vm.id !== '' && _vm.descricao)?_c('span',{staticClass:"id-desc__sep"},[_vm._v("·")]):_vm._e(),(_vm.descricao)?_c('span',{staticClass:"id-desc__desc"},[_vm._v(_vm._s(_vm.descricao))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }